import { Typography } from "@procore/core-react";
import React from "react";

interface AddressDisplayProps {
   address1?: string | null;
   address2?: string | null;
   cityTown?: string | null;
   stateProvince?: string | null;
   zipcode?: string | null;
}

export function AddressDisplay({
   address1,
   address2,
   cityTown,
   stateProvince,
   zipcode,
}: AddressDisplayProps) {
   const hasAnyField = address1 || address2 || cityTown || stateProvince || zipcode;

   if (!hasAnyField) {
      return (
         <Typography className="task-card-body-content-row-item" intent="small">
            {"--"}
         </Typography>
      );
   }

   return (
      <div className="address-display">
         {address1 && (
            <Typography className="task-card-body-content-row-item" intent="small">
               {address1}
            </Typography>
         )}
         {address2 && (
            <Typography className="task-card-body-content-row-item" intent="small">
               {address2}
            </Typography>
         )}
         {(cityTown || stateProvince) && (
            <Typography className="task-card-body-content-row-item" intent="small">
               {[cityTown, stateProvince].filter(Boolean).join(", ")}
            </Typography>
         )}
         {zipcode && (
            <Typography className="task-card-body-content-row-item" intent="small">
               {zipcode}
            </Typography>
         )}
      </div>
   );
}
